module.exports = __webpack_public_path__ + "img/CCLF_infographic-15.17f2184d.png";